
import React from 'react';
import Calendar from 'calendar';

import moment from 'moment';

import translator from 'translate-react';
import { LocalString } from 'translate-react';

import makeReducer from '../src/makeReducer';


var zeroPad = (n) => (n < 10 ? '0' : '') + n;

let now = new Date();

var defaultState = {
    month: now.getMonth() + 1,
    year: now.getFullYear(),

    /* Finally selected start + end, Date objects */
    selectionStart: null,
    selectionEnd: null,

    /* Selection state */
    selecting: false,
    selectionStartHover: null,
    selectionEndHover: null,

    /* Defines the behaviour of the selection in terms of nights
        none = Calendar is empty (no selection)
        exact = nights will be set to: (selectionEnd - selectionStart)
        flex = selection and nights are independent (used for range based search)
    */
    selectionMode: 'exact', /* none, exact, flex */
    nights: 0,

    //selectionStart: new Date("2016-09-21"),
    //selectionEnd: new Date("2016-10-02"),
};

import {
    CLICK_DAY,
    HOVER_DAY,
    SET_PERIOD,
    THIS_MONTH,
    NEXT_MONTH,
    PREV_MONTH,
    RESET_DATE,
    SET_SELECTION,
    ABORT_SELECTION,
    clickDay,
    hoverDay,
    setPeriod,
    thisMonth,
    nextMonth,
    prevMonth,
} from '../actions';


export var calendarReducer = makeReducer({

    default: _ => defaultState,

    [SET_PERIOD]: (state, action) => {
        if ( action.year ) state = { ...state, year: action.year };
        if ( action.month ) state = { ...state, month: action.month };
        return state;
    },

    [SET_SELECTION]: (state, action) => {
        return {
            ...state,
            selectionStart: action.start,
            selectionEnd: action.end,
            selecting: false,
            selectionStartHover: null,
            selectionEndHover: null,
        }
    },

    [THIS_MONTH]: (state, action) => {
        var now = new Date();
        return { ...state, month: now.getMonth() + 1, year: now.getFullYear() };
    },

    [NEXT_MONTH]: (state, action) => {
        if ( state.month === 12 ) {
            return { ...state, month: 1, year: state.year + 1 };
        } else {
            return { ...state, month: state.month + 1 };
        }
    },

    [PREV_MONTH]: (state, action) => {
        let now = new Date();
        if ( state.year <= now.getFullYear() && (now.getMonth() + 1) >= state.month ) {
            return state;
        }

        if ( state.month === 1 ) {
            return { ...state, month: 12, year: state.year - 1 };
        } else {
            return { ...state, month: state.month - 1 };
        }
    },

    [CLICK_DAY]: (state, action) => {
        if ( typeof action.date === "object" ) {
            throw new Error("CLICK_DAY received an object as action.date, but just needs the .date");
        }

        if ( !state.selecting ) {
            /* First click on a day (defines the start) */
            state = {
                ...state,
                selectionStart: null,
                selectionEnd: null,

                selecting: true,
                selectionStartHover: new Date(action.date),
                selectionEndHover: null,
            };
            if ( state.selectionMode === "none" ) {
                state.selectionMode = "exact";
            }
            if ( state.selectionMode === "exact"  ) {
                state.nights = 0;
            }
        } else {
            /* Second click on a day (defines the end) */
            state = {
                ...state,
                selectionStart: state.selectionStartHover,
                selectionEnd: new Date(action.date),
                selectionStartHover: null,
                selectionEndHover: null,
                selecting: false,
            };

            if ( state.selectionMode === "exact" && state.selectionStart && state.selectionEnd ) {
                state.nights = moment(state.selectionEnd).diff(moment(state.selectionStart), 'days');
            }
        }
        console.log("=> DATE", action.date, new Date(action.date));
        console.log("=> STATE", state);
        return state
    },

    [HOVER_DAY]: (state, action) => {
        if ( state.selecting ) {
            state = {
                ...state,
                selectionEndHover: new Date(action.date)
            };

            if ( state.selectionMode === "exact" ) {
                state.nights = moment(state.selectionEndHover).diff(moment(state.selectionStartHover), 'days');
            }
        }
        return state
    },

    [RESET_DATE]: (state, action) => {
        return {
            ...state,
            nights: 0,
            selectionMode: "none",
            selectionStart: null,
            selectionEnd: null,
            selectionStartHover: null,
            selectionEndHover: null,
            selecting: false,
        }
    },

    [ABORT_SELECTION]: (state, action) => {
        return {
            ...state,
            selecting: false,
            selectionStartHover: null,
            selectionEndHover: null,
        }
    },

});



let c = new Calendar();

/**
 * Generates the calendar view for a month.
 * Returns a list of weeks, each weeks contains of 7 objects with the following attributes:
 *
 * - day:          Day number (1-31)
 * - month:        Month number (1-12)
 * - year:         Full year
 * - date:         Date (YYYY-MM-DD)
 * - weekday:      Weekday (0 = Monday, 6 = Sunday)
 * - weekday_name: Localised weekday name
 * - today:        (bool) Current day?
 * - selected:     (cool) Currently selected?
 * - weekend:      (bool) Saturday or sunday?
 *
 * @param year {Number} Year (1970 - eternity)
 * @param month {Number} Month (1-12)
 * @param start {Number} Start day for selection (Date object)
 * @param end {Number} End day for selection (Date object)
 * @param max_select_days {Number} Max amount of nights starting from start (1-21)
 * @param selecting {Bool} Calendar currently selecting?
 */
var generate_calendar = (year, month, start, end, max_select_days, selecting) => {
    let today = new Date();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);

    let today_day = today.getDate();
    let today_month = today.getMonth() + 1;
    let today_year = today.getFullYear();
    max_select_days = max_select_days || 0;

    let start_time, end_time;
    if ( start instanceof Date ) {
        start_time = +start;
    }
    if ( end instanceof Date ) {
        end_time = +end;
    }

    let weeks = c.monthDays(year, month - 1);
    return _.map(weeks, function(week) {
        return _.map(week, function(day, weekday) {
            if ( day === 0 ) return null;
            let date = year + "-" + zeroPad(month) + "-" + zeroPad(day);
            let date_ts = +(new Date(date));
            let selected = false;
            let selection_start = false;
            let selection_end = false;
            let selection_single = false;

            selected = date_ts >= start_time && ( (!end_time && date_ts === start_time) || date_ts <= end_time );
            selection_start = date_ts == start_time && date_ts !== end_time;
            selection_end = date_ts == end_time && date_ts !== start_time;
            selection_single = date_ts === start_time && ( !end_time || start_time === end_time );

            return {
                day,
                month,
                year,
                date,
                weekday,
                selected,
                selection_start,
                selection_end,
                selection_single,
                past: date_ts < +today,
                disabled: (
                        /* Not before today */
                        date_ts < +today
                        /* Limit to X days */
                    || ( selecting && date_ts > (start_time +  max_select_days * 86400000) )
                        /* Not before start day, if selecting */
                    || ( selecting && start_time && date_ts < start_time )
                ),
                today: (day === today_day && month === today_month && year === today_year),
                weekend: (weekday == 5 || weekday == 6),
            };
        });
    });
}


export var CalendarComponent = function(props) {
    var {
        year, month, offset, showPrev, showNext,
        selectionStart, selectionEnd,
        selecting, selectionStartHover, selectionEndHover,
        onClick, onHover, nextMonth, prevMonth,
    } = props;

    while ( offset > 0 ) {
        if ( month === 12 ) {
            year++;
            month = 1;
        } else {
            month++;
        }
        offset--;
    }

    let weeks = generate_calendar(
        year, month,
        selectionStart || selectionStartHover,
        selectionEnd || selectionEndHover,
        21, // max_select_days
        selecting
    );

    let touchEvent;
    if ( 'ontouchstart' in window ) {
        /*
        window.calendarLastTouchDay = null;
        touchEvent = (e) => {
            e.preventDefault();
            
            console.log(e.type);
            console.log(e.currentTarget);
            console.log(window.calendarLastTouchDay);

            if ( e.touches[0] ) {
                let x = e.touches[0].clientX;
                let y = e.touches[0].clientY;

                // Find all cells which might be inside the event area
                let rows = e.currentTarget.childNodes;
                let found_cell = false;
                for(let i = 0; i < rows.length; i++) {
                    let cells = rows[i].childNodes;
                    if ( found_cell ) break;

                    for(let j = 0; j < cells.length; ++j ) {
                        let rect = cells[j].getBoundingClientRect();
                        if ( found_cell ) break;

                        if ( !cells[j].dataset.index ) return;

                        let inside = (
                               x >= rect.left
                            && y >= rect.top
                            && x <= (rect.left + rect.width)
                            && y <= (rect.top + rect.height)
                        );
                        if ( inside ) {
                            let index_parts = cells[j].dataset.index.split('.');
                            window.calendarLastTouchDay = weeks[index_parts[0]][index_parts[1]];
                            found_cell = true;
                        }
                    }
                }
            }

            if ( window.calendarLastTouchDay && !window.calendarLastTouchDay.disabled ) {
                if ( e.type === "touchstart" || e.type === "touchend" || e.touches.length === 0 ) {
                    console.log("Triggering onClick");
                    onClick ? onClick(window.calendarLastTouchDay) : null;
                } else if ( e.type === "touchmove" ) {
                    console.log("Triggering onHover");
                    onHover ? onHover(window.calendarLastTouchDay) : null;
                }
            }
        };
        */
    }

    let weekdays = translator.get("dayNamesShort");
    let monthnames = translator.get("monthNames");

    if ( weekdays === "dayNamesShort" || monthnames === "monthNames" ) {
        throw new Error("Calendar: Please initialize react-translate before using the Calendar component");
    }

    return (
        <table cellSpacing="0" className="calendar">
            <thead>
                <tr className="calendar-month">
                    <th colSpan="7">
                        {prevMonth ? <button className="calendar-prevmonth" onClick={prevMonth}>&lsaquo;</button> : null }
                        {nextMonth ? <button className="calendar-nextmonth" onClick={nextMonth}>&rsaquo;</button> : null }
                        <div className="calendar-month-title">
                            <LocalString word={monthnames[weeks[1][0].month - 1]} />
                            {' '}
                            {weeks[1][0].year}
                        </div>
                    </th>
                </tr>
                <tr className="calendar-weekdays">
                    <th>{weekdays[0]}</th>
                    <th>{weekdays[1]}</th>
                    <th>{weekdays[2]}</th>
                    <th>{weekdays[3]}</th>
                    <th>{weekdays[4]}</th>
                    <th>{weekdays[5]}</th>
                    <th>{weekdays[6]}</th>
                </tr>
            </thead>
            <tbody onTouchStart={touchEvent} onTouchMove={touchEvent} onTouchEnd={touchEvent}>
                { _.map(weeks, (week, i) => { return <CalendarRow index={i} week={week} key={i} onClick={onClick} onHover={onHover} /> }) }
            </tbody>
        </table>
    );
};


var CalendarRow = function(props) {
    return (
        <tr>
            { _.map(props.week, (day, j) => 
                <CalendarCell
                    index={props.index + '.' + j}
                    day={day}
                    key={j}
                    onClick={props.onClick}
                    onHover={props.onHover}
                />
            ) }
        </tr>
    );
};


var CalendarCell = function(props) {
    let { day, onClick, onHover, index, touchEvent } = props;
    if ( day === null ) return <td className="empty"></td>;

    let classes = [];
    if ( day.today ) classes.push("today");
    if ( day.selected ) classes.push("selected");
    if ( day.selection_start ) classes.push("selection_start");
    if ( day.selection_end ) classes.push("selection_end");
    if ( day.selection_single ) classes.push("selection_single");
    if ( day.weekend ) classes.push("weekend");
    if ( day.disabled ) classes.push("disabled");
    if ( day.past ) classes.push("past");

    return (
        <td className={classes.join(" ")}
            data-index={index}
            onClick={(e) => onClick && !day.disabled ? onClick(day) : null}
            onMouseOver={(e) => onHover && !day.disabled ? onHover(day) : null}
        >
            <div>{day.day}</div>
        </td>
    );
};




/** WEBPACK FOOTER **
 ** ../ibe/components/Calendar.js
 **/